import { dateFormatter, useTranslation } from '@fareye/common'
import { Card, Flex, Label, Span, styled } from '@fareye/ui'
import {
  DMYYY,
  FaCheckCircle,
  FaTimesCircle,
  hhmmANoIST,
  isEmpty,
  startCase
} from '@fareye/utils'
import React from 'react'
import { displayTime } from '../../../utility/function'
import { TimeLine } from './TimeLine'
import TimeLineTable from './TimeLineTable'
export const TimelineData = [
  {
    milestoneName: 'Order Created',
    sequenceNo: 0,
    isCompleted: true,
    packageStatus: 'ORDER_CREATED',
    milestoneEventTime: '2021-08-28 08:20:35',
    rawStatusData: [
      {
        activity: 'Order Created',
        location: 'dummy_location',
        dateTime: '2021-08-28 08:20:35',
        status: 'Order Created'
      },
      {
        activity: 'order_created_succesfully',
        location: 'dummy_location',
        dateTime: '2021-08-28 08:21:35',
        status: 'Order Created'
      },
      {
        activity: 'order_created_succesfully',
        location: 'dummy_location',
        dateTime: '2021-08-28 08:21:35',
        status: 'Order Created'
      }
    ]
  },
  {
    milestoneName: 'Avialable for Pickup',
    sequenceNo: 1,
    isCompleted: true,
    packageStatus: 'AVAILABLE_FOR_PICKUP',
    milestoneEventTime: '2021-08-28 09:21:35',
    rawStatusData: [
      {
        activity: 'AVAILABLE_FOR_PICKUP',
        location: 'dummy_location',
        dateTime: '2021-08-28 09:21:35',
        status: 'AVAILABLE_FOR_PICKUP'
      }
    ]
  },
  {
    milestoneName: 'Cancelled',
    sequenceNo: 1,
    isCompleted: true,
    packageStatus: 'CANCELLED',
    milestoneEventTime: '2021-08-28 09:21:35',
    rawStatusData: [
      {
        activity: 'AVAILABLE_FOR_PICKUP',
        location: 'dummy_location',
        dateTime: '2021-08-28 09:21:35',
        status: 'AVAILABLE_FOR_PICKUP'
      }
    ]
  },
  {
    milestoneName: 'In Transit',
    sequenceNo: 2,
    isCompleted: false,
    packageStatus: 'IN_TRANSIT',
    milestoneEventTime: '2021-08-28 09:21:35',
    rawStatusData: [
      {
        activity: "it's in transit",
        location: 'dummy_location',
        dateTime: '2021-08-28 09:21:35',
        status: 'In Transit'
      },
      {
        activity: "it's in transit",
        location: 'dummy_location',
        dateTime: '2021-08-28 09:21:35',
        status: 'In Transit'
      }
    ]
  },
  { milestoneName: 'At_destination_hub', sequenceNo: 3, isCompleted: true },
  {
    milestoneName: 'OUT For Delivery',
    sequenceNo: 4,
    isCompleted: false,
    packageStatus: 'OUT_FOR_DELIVERY',
    milestoneEventTime: '2021-08-28 09:40:35',
    rawStatusData: [
      {
        activity: 'OUT_FOR_DELIVERY',
        location: 'dummy_location',
        dateTime: '2021-08-28 09:40:35',
        status: 'OUT_FOR_DELIVERY'
      }
    ]
  },
  {
    milestoneName: 'UNDELIVERED',
    sequenceNo: 5,
    isCompleted: false,
    packageStatus: 'UNDELIVERED',
    milestoneEventTime: '2021-08-28 09:40:35',
    rawStatusData: [
      {
        activity: 'DELIVERED',
        location: 'dummy_location',
        dateTime: '2021-08-28 09:40:35',
        status: 'DELIVERED'
      }
    ]
  }
]
export const ColumnConfig = [
  { label: 'Activity', key: 'activity' },
  { label: 'Location', key: 'location' },
  { label: 'Date & Time', key: 'dateTime' },
  { label: 'Carrier Status', key: 'status' }
]

const Line = styled.span`
  position: absolute;
  left: 6px;
  top: 13px;
  height: calc(100% - 10px);
  border: ${(props: any) => `1px solid ${props.theme.colors[props.color]}`};
`
const HalfLine1 = styled.span`
  position: absolute;
  left: 6px;
  top: 13px;
  border: 1px solid #009c31;
  height: calc(50% - 5px);
`
const HalfLine2 = styled.span`
  position: absolute;
  left: 6px;
  top: calc(50% + 8px);
  border: 1px solid rgba(140, 140, 140, 1);
  height: calc(50% - 5px);
`

const SelectedIcon = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 100px;
  background-color: #009c31;
  animation: glow 2s infinite alternate;
  @keyframes glow {
    0% {
      box-shadow: 0 0 10px -10px #009c31;
    }
    50% {
      box-shadow: 0 0 10px 10px rgba(0, 156, 49, 0.5);
    }
    100% {
      box-shadow: 0 0 10px 10px rgba(0, 156, 49, 0.1);
    }
  }
`
const UnVisitedNodesIcon = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 100px;
  background-color: #adadad;
`
const Summary = styled.summary`
  color: #006491;
  padding: 10px 0 0 0;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`
const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props: any) => props.color};
`
const HorizontalLine = styled.div`
  border: ${(props: any) => `1px dashed ${props.color}`};
  width: 70px;
`
const PACKAGE_STATUS = {
  UNDELIVERED: 'UNDELIVERED',
  CANCELLED: 'CANCELLED'
}
export default function VerticalTimeLine({ timelineData, data }: any) {
  const { origin, destination } = data
  const { t } = useTranslation()
  function getIcon(isCompleted: boolean, packageStatus: string) {
    if (
      packageStatus === PACKAGE_STATUS.UNDELIVERED ||
      packageStatus === PACKAGE_STATUS.CANCELLED
    ) {
      return (
        <FaTimesCircle
          color="#DA1E28"
          size={14}
          style={{ background: '#fff' }}
        />
      )
    } else if (isCompleted) {
      return (
        <FaCheckCircle
          color="#409e33"
          size={14}
          style={{ background: '#fff' }}
        />
      )
    } else {
      return <UnVisitedNodesIcon />
    }
  }
  function getLineStyle(ele: any, index: number) {
    let color = 'green5'
    let lastNodeIndex = timelineData.length - 1
    let drawHalfLine = false
    if (lastNodeIndex >= index + 1) {
      if (ele.packageStatus == PACKAGE_STATUS.CANCELLED) {
        color = 'gray5'
      } else if (timelineData[index + 1].isCompleted) {
        color = 'green5'
      } else if (ele.isCompleted) {
        color = 'gray5'
        drawHalfLine = true
      } else {
        color = 'gray5'
      }
    }
    if (drawHalfLine) {
      return (
        <>
          <HalfLine1 color={'green5'} />
          <HalfLine2 color={'gray5'} />
        </>
      )
    }

    return <Line color={color} />
  }

  function generateTableData(ele: any, index: number) {
    const data = ele.rawStatusData
    return <TimeLineTable data={data} columns={ColumnConfig} />
  }
  function generateOriginDestinationLine() {
    return (
      <Flex alignItemsCenter>
        <Label style={{ maxWidth: '100px' }} variant="ellipsis">
          {origin}
        </Label>
        <Flex alignItemsCenter m={2}>
          <Dot color="#aaa" />
          <HorizontalLine color="#979797" />
          <Dot color="#212121" />
        </Flex>
        <Label style={{ maxWidth: '100px' }} variant="ellipsis">
          {destination}
        </Label>
      </Flex>
    )
  }

  return (
    <Card bodyStyle={{ padding: '18px' }}>
      <TimeLine
        styles={{ frame: { padding: '10px' } }}
        size="xxl"
        variant="vertical"
      >
        <>
          <Flex justifyContentFlexEnd>{generateOriginDestinationLine()}</Flex>
          {timelineData.map((ele: any, i: number) => {
            return (
              <Flex style={{ minHeight: '85px' }} key={`time-index-${i}`}>
                <Flex style={{ textAlign: 'right', minWidth: '60px' }} column>
                  <Span>
                    {ele.milestoneEventTime
                      ? dateFormatter(ele.milestoneEventTime, 'dMyyy')
                      : '-'}
                  </Span>
                  <Span variant="secondary">
                    {ele.milestoneEventTime
                      ? displayTime(ele.milestoneEventTime, 'hhmma')
                      : '-'}
                  </Span>
                </Flex>
                <Flex style={{ position: 'relative', margin: '0 15px' }} column>
                  {getIcon(ele.isCompleted, ele.packageStatus)}
                  {timelineData.length !== i + 1 && getLineStyle(ele, i)}
                </Flex>
                <Flex column>
                  <Label>{t(startCase(ele.milestoneName))}</Label>
                  {ele.isCompleted && !isEmpty(ele.rawStatusData) && (
                    <Flex column>
                      <details>
                        <Summary>
                          <Span
                            style={{
                              color: '#006491',
                              padding: '10px 0px 0px',
                              cursor: 'pointer',
                              fontSize: ' 12px'
                            }}
                          >
                            {t('See All Updates')}
                          </Span>
                        </Summary>
                        {generateTableData(ele, i)}
                      </details>
                    </Flex>
                  )}
                </Flex>
              </Flex>
            )
          })}
        </>
      </TimeLine>
    </Card>
  )
}
